<template>
  <div
    style="
      display: flex;
      align-items: center;
      border-top: 1px solid #e2e2e2;
      padding: 20px 0;
    "
  >
    <el-input
      v-model="state.selectFile.name"
      size="large"
      placeholder="--请选择文件--"
      readonly
    ></el-input>
    <el-upload
      action="#"
      :show-file-list="false"
      ref="uploadDom"
      accept=".xlsx"
      :auto-upload="false"
      :on-change="onFileChange"
    >
      <template #default>
        <el-button type="primary" size="large" style="margin-left: 10px">
          选择文件
        </el-button>
      </template>
    </el-upload>
  </div>
  <div style="display: flex; align-items: center; justify-content: center">
    <el-button type="success" @click="onSubmitImport">确定导入</el-button>
    <el-button type="warning" @click="onDownLoad">模板下载</el-button>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  calctaxoutsource_import,
  calctaxoutsource_download,
} from "@/http/calctaxoutsource";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({ selectFile: {} });
    onMounted(() => {});

    //选择文件
    const onFileChange = (file) => {
      state.selectFile = file;
    };

    const onSubmitImport = () => {
      if (!state.selectFile?.raw) {
        ElMessage({
          type: "warning",
          message: "请选择文件！",
          grouping: true,
        });
        return false;
      }

      const formData = new FormData();
      //把接口需要的参数带进去
      formData.append("id", props.id);
      formData.append("file", state.selectFile.raw);
      calctaxoutsource_import(formData)
        .then((res) => {
          if (res.status == 200) {
            if (res.data?.data?.error_count > 0) {
              ElMessageBox.confirm(
                "<text style='color:#080'>工资表导入成功！</text><text style='color:#ffa500'>部分员工数据与系统现存数据存在差异，需人工处理后方可生效，是否立即处理？</text>",
                "导入结果通知",
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "去处理",
                  cancelButtonText: "稍后处理",
                  type: "success",
                }
              )
                .then(() => {
                  emit("success", true);
                })
                .catch(() => {
                  emit("success");
                });
            } else {
              ElMessage.success(res.data.msg);
              emit("success");
            }
          }
        })
        .catch((err) => {
          ElMessage.error(err.data.msg);
          emit("success");
        });
    };

    const onDownLoad = () => {
      calctaxoutsource_download(props.id)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return { state, onFileChange, onSubmitImport, onDownLoad };
  },
};
</script>
<style scoped></style>
